import { useForm } from "react-hook-form";
import { AddressTypes, useAddress } from "customer/settings/address/address.service";
import { atom, useRecoilState } from "recoil";
import { useLookups } from "shared/hooks/use-lookups";
import { useQuery } from "react-query";
import { useAuthContext } from "shared/context/auth-context";
import { client } from "shared/helpers/client";
import * as yup from "yup";
import React from "react";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";


interface NewOrderData {
  pickPoint: string;
  deliveryPoint: string;
  shippingDate: Date;
  serviceType: string;
}

interface ShippingDetailsData {
  customer: string;
  vehicle: number;
  goodsType:number;
  weight:number;
  unit:number;
  price:number,
  goodDescription:string;
}

interface AddressData {
  type: AddressTypes;
  name: string;
  cityId: number;
  location?: {
    lat: number;
    lng: number;
  };
  contactPerson?: string;
  phone?: string;
  neighborhood?: string;
  street?: string;
  buildingNumber?: number;
  apartmentNumber?: number;
  fullAddress?: string;
}

type OrderData = NewOrderData & ShippingDetailsData & AddressData



const newOrderAtom = atom<OrderData | undefined>({
  key:'order',
  default: undefined
})

export function useCreateOrder() {
  const {t} = useTranslation();
  const [{user}] = useAuthContext();
  const [orderData,setOrderData] = useRecoilState(newOrderAtom)


  // Schemas
  const newOrderSchema = React.useMemo(()  =>  yup.object().shape({
    pickPoint: yup.string().required(t('errors.required')),
    deliveryPoint: yup.string().required(t('errors.required')),
    shippingDate: yup.string().required(t('errors.required')),
    serviceType: yup.string().required(t('errors.required')),
  }),[t] );

  const shippingDetailsSchema = React.useMemo(()  =>  yup.object().shape({
    customer: yup.string().required(t('errors.required')),
    vehicle: yup.number().required(t('errors.required')),
    goodsType:yup.number().required(t('errors.required')),
    weight:yup.string().required(t('errors.required')),
    unit:yup.number().required(t('errors.required')),
    price:yup.string().required(t('errors.required')),
    goodDescription:yup.string().required(t('errors.required')),
  }),[t] )


  const addressSchema = React.useMemo(()  =>  yup.object().shape({
    type: yup.number().required(t('errors.required')),
    name: yup.string().required(t('errors.required')),
    cityId: yup.number().required(t('errors.required')),
  }),[t] )

  // Forms
  const newOrderForm = useForm<NewOrderData>({resolver:yupResolver(newOrderSchema)});
  const shippingDetailsForm = useForm<ShippingDetailsData>({resolver:yupResolver(shippingDetailsSchema)});
  const pickPointForm = useForm<AddressData>({resolver:yupResolver(addressSchema)});
  const deliveryPointForm = useForm<AddressData>({resolver:yupResolver(addressSchema)});

  const {addresses: pickPoints} = useAddress(AddressTypes.Company);
  const {addresses: deliveryPoints} = useAddress(AddressTypes.Customer);

 // const {serviceTypes,vehicles,goodTypes} = useLookups(['service-types','goods-type','vehicles'])

  // const {data:customers} = useQuery(['customers', user.sub], () => {
  //   return client('/authorizedPersons/getAllAuthorizedPersonsLookup',{params:{CustomerUserId:user.sub}}).then(r => r.response);
  // })


  return {
  
    newOrderForm,
    shippingDetailsForm,
    pickPointForm,
    pickPoints,
   
    deliveryPoints,
    orderData,
    setOrderData,
    deliveryPointForm
  }
}